const gerSortedFilteredList = (list) => {
  list.sort((a, b) => {
    let x = a.title().toLowerCase()
    let y = b.title().toLowerCase()
    if (x < y) {
      return -1
    }
    if (x > y) {
      return 1
    }
    return 0
  })

  return list.filter((item) => item.scope === true)
}

export function listGeneral() {
  let general = [
    {
      code: 'DVC-A1/S1',
      title: () => {
        return this.$t('global.alert.sosButton')
      },
      scope: this.hasAccess(['webhook_event_a1_s1:read']),
    },
    {
      code: '',
      title: () => {
        return this.$t('global.alert.gpsDisarmed')
      },
      scope: null,
    },
    {
      code: 'DVC-A1/T1',
      title: () => {
        return this.$t('global.alert.temperature')
      },
      scope: this.hasAccess(['webhook_event_a1_t1:read']),
    },
    {
      code: '',
      title: () => {
        return this.$t('global.alert.lowBattery')
      },
      scope: null,
    },
    {
      code: '',
      title: () => {
        return this.$t('global.alert.gpsWeakSignal')
      },
      scope: null,
    },
    {
      code: '',
      title: () => {
        return this.$t('global.alert.vibration')
      },
      scope: null,
    },
    {
      code: 'DVC-A1/E1',
      title: () => {
        return this.$t('notification.field.machineOn/Off')
      },
      scope: this.hasAccess(['webhook_event_a1_e1:read']),
    },
    {
      code: 'DVC-A1/G1',
      title: () => {
        return this.$t('global.alert.geofence')
      },
      scope: this.hasAccess(['webhook_event_a1_g1:read']),
    },
    {
      code: 'DVC-A1/F1',
      title: () => {
        return this.$t('global.alert.fuel')
      },
      scope: this.hasAccess(['webhook_event_a1_f1:read']),
    },
    {
      code: '',
      title: () => {
        return this.$t('global.alert.pto')
      },
      scope: null,
    },
    {
      code: 'DVC-A1/D1',
      title: () => {
        return this.$t('global.alert.door')
      },
      scope: this.hasAccess(['webhook_event_a1_d1:read']),
    },
    {
      code: '',
      title: () => {
        return this.$t('global.alert.missRoute')
      },
      scope: null,
    },
    {
      code: '',
      title: () => {
        return this.$t('global.alert.idleTime')
      },
      scope: null,
    },
    {
      code: '',
      title: () => {
        return this.$t('global.alert.parkTime')
      },
      scope: null,
    },
    {
      code: '',
      title: () => {
        return this.$t('global.alert.coverRemoved')
      },
      scope: null,
    },
    {
      code: '',
      title: () => {
        return this.$t('global.alert.refrigerator')
      },
      scope: null,
    },
    {
      code: 'DVC-A1/RS1',
      title: () => {
        return this.$t('global.alert.routePlanStart')
      },
      scope: this.hasAccess(['webhook_event_a1_rs1:read']),
    },
    {
      code: 'DVC-A1/RE1',
      title: () => {
        return this.$t('global.alert.routePlanEnd')
      },
      scope: this.hasAccess(['webhook_event_a1_re1:read']),
    },
    {
      code: 'DVC-A1/T2',
      title: () => {
        return this.$t('global.alert.tamper')
      },
      scope: this.hasAccess(['webhook_event_a1_t2:read']),
    },
  ]

  return gerSortedFilteredList(general)
}

export function listDMS() {
  let dms = [
    {
      code: 'DVC-A1/Y1',
      title: () => {
        return this.$t('global.alert.yawning')
      },
      scope: this.hasAccess(['webhook_event_a1_y1:read']),
    },
    {
      code: 'DVC-A1/D2',
      title: () => {
        return this.$t('global.alert.disturbance')
      },
      scope: this.hasAccess(['webhook_event_a1_d2:read']),
    },
    {
      code: 'DVC-A1/S2',
      title: () => {
        return this.$t('global.alert.smoking')
      },
      scope: this.hasAccess(['webhook_event_a1_s2:read']),
    },
    {
      code: 'DVC-A1/PC1',
      title: () => {
        return this.$t('global.alert.calling')
      },
      scope: this.hasAccess(['webhook_event_a1_pc1:read']),
    },
    {
      code: 'DVC-A1/CE1',
      title: () => {
        return this.$t('global.alert.asleep')
      },
      scope: this.hasAccess(['webhook_event_a1_ce1:read']),
    },
    {
      code: 'DVC-A1/MF1',
      title: () => {
        return this.$t('global.alert.outOfFrame')
      },
      scope: this.hasAccess(['webhook_event_a1_mf1:read']),
    },
    {
      code: 'DVC-A1/S4',
      title: () => {
        return this.$t('global.alert.crash')
      },
      scope: this.hasAccess(['webhook_event_a1_s4:read']),
    },
    {
      code: 'DVC-A1/S3',
      title: () => {
        return this.$t('global.alert.seatbelt')
      },
      scope: this.hasAccess(['webhook_event_a1_s3:read']),
    },
    {
      code: 'DVC-A1/F2',
      title: () => {
        return this.$t('global.alert.fatigueDriving')
      },
      scope: this.hasAccess(['webhook_event_a1_f2:read']),
    },
  ]

  return gerSortedFilteredList(dms)
}

export function listDriverBehavior() {
  let driverBehavior = [
    {
      code: 'DVC-A1/HA1',
      title: () => {
        return this.$t('global.alert.suddenAcceleration')
      },
      scope: this.hasAccess(['webhook_event_a1_ha1:read']),
    },
    {
      code: 'DVC-A1/HB1',
      title: () => {
        return this.$t('global.alert.suddenDeceleration')
      },
      scope: this.hasAccess(['webhook_event_a1_hb1:read']),
    },
    {
      code: 'DVC-A1/O1',
      title: () => {
        return this.$t('notification.alert.overspeed')
      },
      scope: this.hasAccess(['webhook_event_a1_o1:read']),
    },
    {
      code: 'DVC-A1/ST1',
      title: () => {
        return this.$t('global.alert.sharpTurn')
      },
      scope: this.hasAccess(['webhook_event_a1_st1:read']),
    },
  ]

  return gerSortedFilteredList(driverBehavior)
}

export function listADAS() {
  let adas = [
    {
      code: '',
      title: () => {
        return this.$t('global.alert.forwardCollison')
      },
      scope: null,
    },
    {
      code: '',
      title: () => {
        return this.$t('global.alert.laneDeparture')
      },
      scope: null,
    },
    {
      code: '',
      title: () => {
        return this.$t('global.alert.headwayMonitor')
      },
      scope: null,
    },
  ]

  return gerSortedFilteredList(adas)
}

export function listDataUpdate() {
  let dataUpdate = [
    {
      code: 'DVC-DU1/L1',
      title: () => {
        return this.$t('global.alert.location')
      },
      scope: this.hasAccess(['webhook_event_du1_l1:read']),
    },
    {
      code: 'DVC-DU1/T1',
      title: () => {
        return this.$t('global.alert.tempCool')
      },
      scope: this.hasAccess(['webhook_event_du1_t1:read']),
    },
    {
      code: 'DVC-DU1/F1',
      title: () => {
        return this.$t('global.alert.fuel')
      },
      scope: this.hasAccess(['webhook_event_du1_f1:read']),
    },
    {
      code: 'DVC-DU1/VS1',
      title: () => {
        return this.$t('report.fields.vehicleStatus')
      },
      scope: this.hasAccess(['webhook_event_du1_vs1:read']),
    },
  ]

  return gerSortedFilteredList(dataUpdate)
}

export function listFleetTask() {
  let fleetTask = [
    {
      code: 'API-DU1/SF1',
      title: () => {
        return this.$t('global.alert.fleetTask.fleetTaskStatus')
      },
      scope: this.hasAccess(['webhook-event-du1-sf1:read']),
    },
    {
      code: 'API-DU1/PP1',
      title: () => {
        return this.$t('global.alert.fleetTask.proofOfTransaction')
      },
      scope: this.hasAccess(['webhook-event-du1-pp1:read']),
    },
    {
      code: 'DVC-DU1/LF1',
      title: () => {
        return this.$t('global.alert.fleetTask.fleetTaskLocation')
      },
      scope: this.hasAccess(['webhook_event_du1_lf1:read']),
    },
    {
      code: 'API-DU1/IF1',
      title: () => {
        return this.$t('global.alert.fleetTask.fleetTaskIntervention')
      },
      scope: this.hasAccess(['webhook-event-du1-if1:read']),
    },
  ]

  return gerSortedFilteredList(fleetTask)
}

export function listQuickAssignment() {
  let quickAssignment = [
    {
      code: 'API-DU1/Q1',
      title: () => {
        return this.$t('global.alert.quickAssignment.updated')
      },
      scope: this.hasAccess(['webhook-event-du1-q1:read']),
    },
    {
      code: 'API-DU1/QS1',
      title: () => {
        return this.$t('global.alert.quickAssignment.statusUpdated')
      },
      scope: this.hasAccess(['webhook-event-du1-qs1:read']),
    },
    {
      code: 'DVC-DU1/QPS1',
      title: () => {
        return this.$t('global.alert.quickAssignment.pointStatusUpdated')
      },
      scope: this.hasAccess(['webhook-event-du1-qps1:read']),
    },
    {
      code: 'DVC-DU1/QL1',
      title: () => {
        return this.$t('global.alert.quickAssignment.location')
      },
      scope: this.hasAccess(['webhook-event-du1-ql1:read']),
    },
    {
      code: 'API-DU1/QPP1',
      title: () => {
        return this.$t('global.alert.quickAssignment.poppod')
      },
      scope: this.hasAccess(['webhook-event-du1-qpp1:read']),
    },
    {
      code: 'API-DU1/QC1',
      title: () => {
        return this.$t('global.alert.quickAssignment.created')
      },
      scope: this.hasAccess(['webhook-event-du1-qc1:read']),
    },
  ]

  return gerSortedFilteredList(quickAssignment)
}

export function getTypeNames(data, groupName) {
  const groupNames = {}
  const typeNames = data.find((group) => group.group === groupName)
  if (!typeNames) return groupNames
  typeNames.events.forEach((event) => {
    groupNames[`${event.source}-${event.event}/${event.type}`] = event
  })
  return groupNames
}
